import React from 'react';

import { Outlet } from 'react-router-dom';

const KitchenExcessReturnContent = () => {
  return <Outlet />;
};

export default KitchenExcessReturnContent;
